// =====================================================
// Global variables
// =====================================================	

const postId 		= (
						undefined === parcelGlobalVars 	|| 
						!parcelGlobalVars 				||
						!parcelGlobalVars.postId 		||
						0 === parcelGlobalVars.postId
					  ) 
						? 0
						: parseInt(parcelGlobalVars.postId),
	  contactPageId = (
	  					undefined === parcelGlobalVars 	||
						!parcelGlobalVars 				||
						!parcelGlobalVars.contactPageId ||
						0 === parcelGlobalVars.contactPageId
					  ) 
						? 0
						: parseInt(parcelGlobalVars.contactPageId);

// Create a global object if it doesn't exist
window.ParcelData = window.ParcelData || {};

// Add properties (variables/constants) to it
window.ParcelData.postId 		= postId;
window.ParcelData.contactPageId = contactPageId;

jQuery(document).ready(function($){ 

  	// =====================================================
	// Greensock global config
	// @here https://greensock.com/docs/v3/GSAP/gsap.config()
	// =====================================================

	gsap.config({
		autoSleep: 60,
		force3D: false,
		//trialWarn: false,
		//units: {left: "%", top: "%", rotation: "rad"}
		nullTargetWarn: false,
	});	

  	// =====================================================
	// jQuery Plugins
	// =====================================================

	// Smartresize ------------------------------------------

	(function($,sr){

		// debouncing function from John Hann
		// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
		var debounce = function (func, threshold, execAsap) {
			var timeout;

			return function debounced () {
				var obj = this, args = arguments;
				function delayed () {
					if (!execAsap)
						func.apply(obj, args);
					timeout = null;
				}

				if (timeout)
					clearTimeout(timeout);
				else if (execAsap)
					func.apply(obj, args);

				timeout = setTimeout(delayed, threshold || 100);
			};
		
		}

		jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

	})(jQuery,'smartresize');

	// Smartscroll ------------------------------------------

	(function($,sr){

		// debouncing function from John Hann
		// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
		var debounce = function (func, threshold, execAsap) {
			var timeout;

			return function debounced () {
				var obj = this, args = arguments;
				function delayed () {
					if (!execAsap)
						func.apply(obj, args);
					timeout = null;
				}

				if (timeout)
					clearTimeout(timeout);
				else if (execAsap)
					func.apply(obj, args);

				timeout = setTimeout(delayed, threshold || 100);
			};
		
		}

		jQuery.fn[sr] = function(fn){  return fn ? this.bind('scroll', debounce(fn)) : this.trigger(sr); };

	})(jQuery,'smartscroll');	

	// Toggleclick ------------------------------------------

	$.fn.toggleClick = function() {
	    var functions = arguments
	    return this.each(function () {
	        var iteration = 0
	        $(this).click(function () {
	            functions[iteration].apply(this, arguments)
	            iteration = (iteration + 1) % functions.length
	        })
	    })
	}	

  	// =====================================================
	// Global functions
	// =====================================================		

	window.ParcelFunctions = {

		/**
		 * Global helper for triggering animations or class additions
		 * when an element becomes visible in the viewport.
		 *
		 * @param {Element} triggerEl - The DOM element whose visibility is tracked.
		 * @param {number} isInViewOnLoad - Ratio (0–1) of visibility required on page load to trigger the animation.
		 * @param {number} isInViewScrollTo - Ratio (0–1) of visibility required on scroll to trigger the animation.
		 * @param {string} className - The CSS class to add when the element is visible.
		 * @param {Element} [classElem] - Optional. The element to add the class to. Defaults to triggerEl.
		 *
		 * Example:
		 * parcelFunctions.inViewport(
		 *    document.querySelector('.map-holder'),
		 *    0.3,                // 30% visible on load triggers animation
		 *    0.15,               // 15% visible on scroll triggers animation
		 *    'in-viewport--featured-areas' // class to add
		 * );
		 */
		inViewport: function(triggerEl, isInViewOnLoad, isInViewScrollTo, className, classElem) {

		    // Default to triggerEl if no class target is provided
		    var targetEl = classElem || triggerEl;

		    // Validate element existence
		    if (!triggerEl) {
		        console.warn('inViewport(): trigger element not found.');
		        return;
		    }

		    var computedOpacity = window.getComputedStyle(triggerEl).opacity;
		    /**
		     * Calculates how much of the element is visible
		     * and returns true/false if the required ratio is met.
		     */
		    function checkVisibility(element, ratioRequired) {

		        var rect = element.getBoundingClientRect();
		        var viewportHeight = window.innerHeight;

		        var visibleTop = Math.max(rect.top, 0);
		        var visibleBottom = Math.min(rect.bottom, viewportHeight);
		        var visibleHeight = visibleBottom - visibleTop;
		        var elementHeight = rect.height;

		        var visibilityRatio = visibleHeight / elementHeight;
		        return visibilityRatio >= ratioRequired;
		    
		    }

		    /**
		     * Executes when the element enters the viewport.
		     * Adds the desired class to the target element.
		     */
		    function playTheShow() {
		        if (ScrollTrigger.isInViewport(triggerEl, isInViewScrollTo) && computedOpacity === '0') {
		        	//console.log(computedOpacity);
		            targetEl.classList.add(className);
		        }
		    }

		    // CASE 1: already in viewport on load → animate immediately
		    if (checkVisibility(triggerEl, isInViewOnLoad)) {
		        targetEl.classList.add(className);
		        return;
		    }

		    // CASE 2: not visible yet → watch scroll position
		    ScrollTrigger.create({
		        start: 0,
		        end: 'max',
		        onUpdate: playTheShow
		    });
		},

	}		

})